/**
 * The course a recipe is served as, folded from its recipe category (POS2-1456). Menu detail shows
 * it per row; All recipes filters by it.
 */

export type Course = "starter" | "main" | "side" | "dessert";

export const COURSES: Course[] = ["starter", "main", "side", "dessert"];

/** Every slug `recipe_categories` holds. */
const COURSE_OF_CATEGORY: Record<string, Course> = {
  soup: "starter",
  starter: "starter",
  "main-course": "main",
  sandwich: "main",
  breakfast: "main",
  "side-dish": "side",
  "sauce-condiment": "side",
  snack: "side",
  beverage: "side",
  dessert: "dessert",
};

/** The category a recipe gets when its course is picked: the course's own. */
export const CATEGORY_OF_COURSE: Record<Course, string> = {
  starter: "starter",
  main: "main-course",
  side: "side-dish",
  dessert: "dessert",
};

export const COURSE_LABELS: Record<Course, string> = {
  starter: "menus.course.starter",
  main: "menus.course.main",
  side: "menus.course.side",
  dessert: "menus.course.dessert",
};

/** The course of a recipe category; null for a recipe with no category. */
export function courseOf(categorySlug: string | null): Course | null {
  if (categorySlug === null) return null;
  const course = COURSE_OF_CATEGORY[categorySlug];
  if (!course) throw new Error(`recipe category ${categorySlug} has no course`);
  return course;
}
